import Aos from "aos";
import React, { useEffect } from "react";
import painting from "../../assets/gele2.jpg";
function Airdrop(props) {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });
  return (
    <div className="bg-[#04091a] flex flex-col md:flex-row justify-around p-10 md:p-20">
      <div data-aos="flip-up">
        <img className="mt-[-150px] w-[300px] md:w-2/3" src={painting} alt="" />
        <div className="md:px-5">
          <h1 className="text-white text-xl md:text-[30px] mt-5 font-black">
            My Meka (0)
          </h1>
          <p className="text-slate-500">You are not connected on Metamask.</p>
        </div>
      </div>
      <div
        data-aos="fade-up"
        data-aos-anchor-placement="top-center"
        className="flex flex-col justify-center"
      >
        <h1 className="text-white text-xl md:text-[50px]">
          Claim your Airdrop
        </h1>
        <h1 className="text-[#d02561] text-xl mt-3">
          {" "}
          2 days,19 hours,09 minutes,42 seconds left to claim{" "}
        </h1>
        <div className="border w-[300px] md:justify-center md:mr-auto flex ml-auto mt-10">
          <input
            type="text"
            className="px-4 py-2"
            placeholder="Enter the ID #"
          />
          <button className="flex items-center text-center justify-center px-2 border-l">
            Check
          </button>
        </div>
      </div>
    </div>
  );
}

export default Airdrop;
